import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { SupplierStatusEnum } from '../enums/supplier-status.enum';
import { SupplierTypeEnum } from '../enums/supplier-type.enum';

/**
 * Supplier DTO for records
 */
@CaslSubject(AppSubjectEnum.SUPPLIER)
export class SupplierRecordDto extends BaseDto {
  code!: string;
  status!: SupplierStatusEnum;
  notes?: string | null;
  type!: SupplierTypeEnum;
  contact!: TenantContactDto;
  tags?: TagListDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
